import React from'react';
//rotas
import {BrowserRouter, Routes, Route} from 'react-router-dom';
//pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
//componentes
import Navbar from './components/Navbar';
import Footer from './components/Footer/Footer';
import FleetList from './components/FleetList';
import TourList from './components/TourList';
import ServiceList from './components/ServiceList';

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/vehicles' element={<FleetList />} />
          <Route path='/our-tours' element={<TourList />} />
          <Route path='/services' element={<ServiceList />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </>
  );
}

export default App;